const nameSpace = 'pointGroupOperation'

export const mutations = {
  SET_TABLE_DATA: `${nameSpace}/SET_TABLE_DATA`,
  SET_TARGET_GROUP: `${nameSpace}/SET_TARGET_GROUP`,
  SET_TARGET_GROUP_NOT_POINT: `${nameSpace}/SET_TARGET_GROUP_NOT_POINT`,
}

export const actions = {
  SET_PAGE_PERMISSION: `${nameSpace}/SET_PAGE_PERMISSION`,
  GET_GROUP_LIST: `${nameSpace}/GET_GROUP_LIST`,
  SET_TARGET_GROUP: `${nameSpace}/SET_TARGET_GROUP`,
  SET_TARGET_GROUP_NOT_POINT: `${nameSpace}/SET_TARGET_GROUP_NOT_POINT`,
  CLEAR_TARGET_GROUP: `${nameSpace}/CLEAR_TARGET_GROUP`,
  RESET_TARGET_GROUP: `${nameSpace}/RESET_TARGET_GROUP`,
  EDIT_GROUP_POINT: `${nameSpace}/EDIT_GROUP_POINT`,
  SET_CURRENT_POINT_LIST: `${nameSpace}/SET_CURRENT_POINT_LIST`,
  ADD_NEW_POINT: `${nameSpace}/ADD_NEW_POINT`,
  DELETE_NEW_ITEM: `${nameSpace}/DELETE_NEW_ITEM`,
  SET_SELECTED_POINT: `${nameSpace}/SET_SELECTED_POINT`,
  CLEAR_SELECTED_POINT: `${nameSpace}/CLEAR_SELECTED_POINT`,
  EDIT_GROUP_NAME: `${nameSpace}/EDIT_GROUP_NAME`,
  SET_IS_EDITING_POI_CATEGORY: `${nameSpace}/SET_IS_EDITING_POI_CATEGORY`,
  SAVE: `${nameSpace}/SAVE`,
  CHANGE_LOCATION_FILTER: `${nameSpace}/CHANGE_LOCATION_FILTER`,
  SET_LAST_DRAG_END_TIME: `${nameSpace}/SET_LAST_DRAG_END_TIME`,
  INIT: `${nameSpace}/INIT`,
  SET_MAP: `${nameSpace}/SET_MAP`,
  CLEAR_MAP: `${nameSpace}/CLEAR_MAP`,
  SET_MAP_LOADED: `${nameSpace}/SET_MAP_LOADED`,
  SET_POINT_LIST_IN_FRAME_COUNT: `${nameSpace}/SET_POINT_LIST_IN_FRAME_COUNT`,
  SEARCH: `${nameSpace}/SEARCH`,
  CLEAR_SEARCH: `${nameSpace}/CLEAR_SEARCH`,
  FOCUS_SEARCH_RESULT_LIST: `${nameSpace}/FOCUS_SEARCH_RESULT_LIST`,
  FOCUS_NEXT_SEARCH_RESULST: `${nameSpace}/FOCUS_NEXT_SEARCH_RESULST`,
  FOCUS_PREV_SEARCH_RESULST: `${nameSpace}/FOCUS_PREV_SEARCH_RESULST`,
  APPLY_SEARCH_RESULT: `${nameSpace}/APPLY_SEARCH_RESULT`,
  APPLY_FOCUSED_SEARCH_RESULT: `${nameSpace}/APPLY_FOCUSED_SEARCH_RESULT`,
  TRIGGER_FIT_BOUNDS: `${nameSpace}/TRIGGER_FIT_BOUNDS`,
}

export const getters = {
  groupList: `${nameSpace}/groupList`,
  targetGroup: `${nameSpace}/targetGroup`,
  loadingPointList: `${nameSpace}/loadingPointList`,
  initialPointList: `${nameSpace}/initialPointList`,
  currentPointList: `${nameSpace}/currentPointList`,
  isEditingPoiCategory: `${nameSpace}/isEditingPoiCategory`,
  pointListForUI: `${nameSpace}/pointListForUI`,
  selectedPoint: `${nameSpace}/selectedPoint`,
  mapCenter: `${nameSpace}/mapCenter`,
  newItemId: `${nameSpace}/newItemId`,
  pagePermission: `${nameSpace}/pagePermission`,
  locationFilter: `${nameSpace}/locationFilter`,
  lastDragEndTime: `${nameSpace}/lastDragEndTime`,
  targetGroupHasUpdates: `${nameSpace}/targetGroupHasUpdates`,
  filteredPointList: `${nameSpace}/filteredPointList`,
  map: `${nameSpace}/map`,
  mapLoaded: `${nameSpace}/mapLoaded`,
  pointListInFrameCount: `${nameSpace}/pointListInFrameCount`,
  searchResultList: `${nameSpace}/searchResultList`,
  currentSearchResultIndex: `${nameSpace}/currentSearchResultIndex`,
  fitBounds: `${nameSpace}/fitBounds`,
}
